/**
 * Поисковая утилита
 */
export const bSearch = {
    /**
     * Выполняет поиск по массиву и сортирует результаты
     * @param find
     * @param key
     * @param items
     * @param sf
     */
    inArray(find: string, key: string, items: any[], sf?: (o: any, f: string) => number): any[] {
        const ind = items.map((value) => {
            const label = value[key] as string;
            const index = sf ? sf(value, find.toLowerCase()) : label.indexOf(find.toLowerCase());
            return { ...value, _si: index };
        });
        return ind.filter((value) => value._si > -1).sort((a, b) => a._si - b._si);
    },
};
/**
 * Поисковая утилита
 */
export const bSearch = {
    /**
     * Выполняет поиск по массиву и сортирует результаты
     * @param find
     * @param key
     * @param items
     * @param sf
     */
    inArray(find: string, key: string, items: any[], sf?: (o: any, f: string) => number): any[] {
        const ind = items.map((value) => {
            const label = value[key] as string;
            const index = sf ? sf(value, find.toLowerCase()) : label.indexOf(find.toLowerCase());
            return { ...value, _si: index };
        });
        return ind.filter((value) => value._si > -1).sort((a, b) => a._si - b._si);
    },
};
